import type { FC, PropsWithChildren } from 'react'

import { Translation } from '@/app/translations/Translation'

import './NoResults.styles.scss'

export const NoResults: FC<PropsWithChildren> = ({ children }) => (
  <div className="no-results">{children || <Translation id="No results" />}</div>
)
